import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { setSaveDefaultSizeInStampPage } from '../../../api/sealStamp';
import { useAlert } from '../../../hooks/useAlert';
import { Sign } from '../../../model/sign';
import SysConfigStore from '../../../store/common/SysConfigStore';
import ButtonLoading from '../../ui/buttons/ButtonLoading';
import ButtonText from '../../ui/buttons/ButtonText';
import CardBox from '../../ui/containers/CardBox';
import PopupSuccess from '../../ui/popups/PopupSuccess';

type Props = {
	id: string;
	signs: Sign[];
	onReset: () => void;
};

export default function HeaderSaveAction({ id, signs, onReset }: Props) {
	const { t } = useTranslation();
	const location = useLocation();
	const { isComponentEnabled } = SysConfigStore();
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [snackbar] = useAlert();
	const sign = signs[0];

	const handleClose = () => setOpen(false);

	const handleSaveClick = async () => {
		setLoading(true);
		try {
			if (!sign) {
				snackbar(t('modify_seal_stamp_drag_required'), 'error');
				setOpen(false);
				setLoading(false);
				return;
			}

			const width = Math.round(sign.width);
			const height = Math.round(sign.height);

			if (!width || !height) {
				snackbar(t('modify_seal_stamp_drag_required'), 'error');
				setOpen(false);
				setLoading(false);
				return;
			}

			if (window.opener && !window.opener.closed) {
				const widthInput = window.opener.document.getElementById(
					'seal_stamp_standard_first',
				) as HTMLInputElement;
				const heightInput = window.opener.document.getElementById(
					'seal_stamp_standard_second',
				) as HTMLInputElement;

				if (widthInput) widthInput.value = String(width);
				if (heightInput) heightInput.value = String(height);
			}
			if (location.pathname.includes('/sign/modify-contract-seal')) {
				const result = await setSaveDefaultSizeInStampPage(id, width, height, isComponentEnabled);
			}
			window.close();
		} catch (error) {
			snackbar(t('cmmn_error_an_error_occurred_during_storage'), 'error');
			setOpen(false);
			setLoading(false);
		}
	};

	return (
		<CardBox className='grid grid-cols-2 gap-4 p-4'>
			<ButtonText variant='outlined' color='warning' text={t('MSG_ID_908')} onClick={onReset} />
			<>
				<ButtonLoading
					loading={loading}
					variant='contained'
					text={t('label_storage')}
					color='primary'
					onClick={() => setOpen(true)}
				/>

				<PopupSuccess
					size='xsmall'
					open={open}
					loading={loading}
					onConfirm={handleSaveClick}
					onClose={handleClose}
					msg={t('modify_seal_stamp_size_save_confirm')}
				/>
			</>
		</CardBox>
	);
}
